import { jobWorkItemSlipUpdateApi } from "src/domain/api/jobWorkItem/slip/jobWorkItemSlipUpdateApi"

type PayloadShape = Parameters<typeof jobWorkItemSlipUpdateApi>[0]

export async function jobWorkItemSlipUpdateService(payload: PayloadShape, token: string) {
	return await jobWorkItemSlipUpdateApi(payload, token)
}
